import React from "react";
import PropTypes from "prop-types";
import Card from "shared/Card";
import styles from "./VirtualForm.module.css";
import InputItem from "Events/Components/InputItem";
import cardStyles from "../../V1Components/SharedCardStyles.module.css";
import { Select } from "shared/Select/Select";

//Form to fill out information about the virtual event location
export function VirtualForm({ type, setType, link, setLink }) {
  return (
    <Card
      children={
        <section>
          <div className={styles.header}>
            <div className={styles.title}>VIRTUAL</div>
            <hr className={styles.hr} />

            <div className={styles.container}>
              <div className={styles.row}>
                <span className={styles.label}>Virtual Event Type</span>
                <span className={styles.visibleTo}>
                  <Select
                    placeholder={type || "Select"}
                    value={type}
                    options={[
                      "Zoom",
                      "Microsoft Teams",
                      "Dreamstream",
                      "Other",
                    ]}
                    onChange={(value) => setType(value)}
                  />
                </span>
              </div>

              <InputItem
                label="Event Link"
                placeholder="Click to type"
                value={link || ""}
                onChange={(e) => setLink(e.target.value)}
              />
            </div>
          </div>
        </section>
      }
    />
  );
}

VirtualForm.propTypes = {
  type: PropTypes.string,
  setType: PropTypes.func,
  link: PropTypes.string,
  setLink: PropTypes.func,
};

VirtualForm.defaultProps = {
  type: "",
  link: "",
};
